// 功能开关
import { EDRAWMAX_PRODUCT_ENV } from "./global";

let EDRAWMAX_USE_AD = !!~~process.env.EDRAWMAX_USE_AD || false;
let EDRAWMAX_USE_COUPON = !!~~process.env.EDRAWMAX_USE_COUPON || false;
let EDRAWMAX_USE_PRODUCTRECOMMEND = !!~~process.env.EDRAWMAX_USE_PRODUCTRECOMMEND || false; // 是否启用产品推荐
let EDRAWMAX_USE_CUSTOMLIBRARY = !!~~process.env.EDRAWMAX_USE_CUSTOMLIBRARY || false; // 是否启用用户自定义库，包括我的收藏
let EDRAWMAX_USE_SAVE = !!~~process.env.EDRAWMAX_USE_SAVE || false; // 是否启用保存功能
let EDRAWMAX_USE_AUTOSAVE = !!~~process.env.EDRAWMAX_USE_AUTOSAVE || false; // 是否启用自动保存
let EDRAWMAX_USE_AUTOVERSION = !!~~process.env.EDRAWMAX_USE_AUTOVERSION || false; // 是否启用自动保存版本
let EDRAWMAX_USE_CREDIT = !!~~process.env.EDRAWMAX_USE_CREDIT || false; // 是否启用购买模板抵用金

if (EDRAWMAX_PRODUCT_ENV == "production" || EDRAWMAX_PRODUCT_ENV == "test37") {
    EDRAWMAX_USE_AD = true;
    EDRAWMAX_USE_COUPON = true;
    EDRAWMAX_USE_PRODUCTRECOMMEND = true;
    EDRAWMAX_USE_CUSTOMLIBRARY = true;
    EDRAWMAX_USE_SAVE = true;
    EDRAWMAX_USE_AUTOSAVE = true;
    EDRAWMAX_USE_AUTOVERSION = true;
    EDRAWMAX_USE_CREDIT = true;
}
if (EDRAWMAX_PRODUCT_ENV == "private" || EDRAWMAX_PRODUCT_ENV == "workwx" || EDRAWMAX_PRODUCT_ENV == "teamsapp") {
    EDRAWMAX_USE_CUSTOMLIBRARY = true;
    EDRAWMAX_USE_SAVE = true;
    EDRAWMAX_USE_AUTOSAVE = true;
    EDRAWMAX_USE_AUTOVERSION = true;
}

export {
    EDRAWMAX_USE_AD,
    EDRAWMAX_USE_COUPON,
    EDRAWMAX_USE_PRODUCTRECOMMEND,
    EDRAWMAX_USE_CUSTOMLIBRARY,
    EDRAWMAX_USE_SAVE,
    EDRAWMAX_USE_AUTOSAVE,
    EDRAWMAX_USE_AUTOVERSION,
    EDRAWMAX_USE_CREDIT,
};
